var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.5,
    width: 19,
    height: 19,
    rx: 1.5,
    stroke: "#595959"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.65545,
    height: 12.0001,
    transform: "translate(5)",
    fill: "#EAECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93978 0.333068C8.69744 0.506168 7.72808 1.44091 6.79334 2.38719C5.40854 3.79507 5.08542 4.18743 5.02772 4.53363C4.85462 5.45682 5.5124 6.18384 6.4356 6.07998C6.8972 6.03382 7.05876 5.92996 7.75116 5.23756L8.54742 4.45285V7.83406V11.2153L8.93978 11.6076C9.25136 11.9192 9.42446 12 9.79374 12C10.3823 12 10.9131 11.573 11.0862 10.9845C11.1439 10.7421 11.2016 9.25348 11.2016 7.56864V4.57979L11.9979 5.34142C12.7364 6.06844 12.8288 6.1146 13.3134 6.1146C14.2366 6.1146 14.8367 5.31834 14.6059 4.41823C14.5251 4.07203 10.9939 0.425388 10.4861 0.159968C9.98992 -0.105452 9.44754 -0.036212 8.93978 0.333068Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSave);
export default __webpack_public_path__ + "static/media/addSave.ae4b8455462292a22421bfb05d821f17.svg";
export { ForwardRef as ReactComponent };